import classes from './ModalSectionService.module.scss';
import modalBase from '../../../ModalBase/ModalBase.module.scss';
import { FC, useEffect, useRef, useState } from 'react';
import { SectionContent } from './SectionContent/SectionContent';
import { ServiceContent } from './ServiceContent/ServiceContent';
import * as React from 'react';
import classNames from 'classnames';
import { modalsSectionServiceDataType } from '../../../../types/Admin/CategoriesTopicsTypes';
import { SectionOrCategory } from '../../../../types/enums';

type ModalSectionServiceProps = {
  isActive: boolean;
  setActive: (value: boolean) => void;
  activeRowData?: modalsSectionServiceDataType;
  modalMode: string;
  radioType?: string | null;
};
export const ModalSectionService: FC<ModalSectionServiceProps> = ({
  isActive,
  setActive,
  activeRowData,
  modalMode,
  radioType
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(
    radioType || SectionOrCategory.Section
  );
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  const modalRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = (event: MouseEvent): void => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setActive(false);
    }
  };

  useEffect(() => {
    if (radioType) {
      setSelectedValue(radioType);
    } else {
      setSelectedValue(SectionOrCategory.Section);
    }
  }, [radioType]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={classNames(modalBase.modal, { [modalBase.active]: isActive })}>
      <div
        className={classNames(modalBase.container, classes.modalContainer)}
        ref={modalRef}>
        {selectedValue === SectionOrCategory.Section ? (
          <SectionContent
            isActive={isActive}
            selectedRadioValue={selectedValue}
            handleRadioChange={handleRadioChange}
            setActiveModal={setActive}
            modalDataFromTable={activeRowData}
            modalMode={modalMode}
          />
        ) : (
          <ServiceContent
            selectedRadioValue={selectedValue}
            handleRadioChange={handleRadioChange}
            setActiveModal={setActive}
            modalDataFromTable={activeRowData}
            modalMode={modalMode}
          />
        )}
      </div>
    </div>
  );
};
